import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { UpdateChannelMessageRequestFilterSensitiveLog, } from "../models/models_0";
import { de_UpdateChannelMessageCommand, se_UpdateChannelMessageCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class UpdateChannelMessageCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "UpdateChannelMessage", {})
    .n("ChimeSDKMessagingClient", "UpdateChannelMessageCommand")
    .f(UpdateChannelMessageRequestFilterSensitiveLog, void 0)
    .ser(se_UpdateChannelMessageCommand)
    .de(de_UpdateChannelMessageCommand)
    .build() {
}
